import { Card, CardContent, Skeleton } from "@mui/material";

const ChartSkeletonPie = ({ size = 250 }) => (
  <Card
    sx={{
      backgroundColor: "#fff",
      borderRadius: 3,
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
      border: "1px solid #e5e7eb",
    }}
  >
    <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <Skeleton variant="text" width="50%" height={28} sx={{ mb: 2 }} />
      <Skeleton variant="circular" width={size} height={size} sx={{ mb: 1 }} />
    </CardContent>
  </Card>
);

export default ChartSkeletonPie;
